export default function (currentUser, $animate) {
    return {
        priority: 601, // just above ng-if
        terminal: true,
        transclude: 'element',
        link,
        scope: {
            displayTo: '='
        }
    };

    function link(scope, $el, attrs, ctrl, $transclude) {
        currentUser()
        .then(user => {
            const display = user.roles.some(userRole => {
                return scope.displayTo.includes(userRole);
            });

            if (display) {
                $transclude(clonedEl => {
                    $animate.enter(clonedEl, $el.parent(), $el);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/display-to.js